<template>
  <div class="loader fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-70 z-3 m-0">
    <span class="animate-spin h-22 w-22 inline-block rounded-full border border-4 border-wrh-gray-extralight border-r-wrh-blue-light border-t-wrh-blue-light overflow-hidden"></span>
  </div>
</template>
